import React from 'react'
import '../Main.less'

function BrandRules(props) {
    const { size } = props
    return (
        <section className={`rules-wrapper ${size}`}>
            <h5 className="mb-4 text-center">聯盟行銷合作協議</h5>
            <ol className="parent">
                <li className="level-1">...
                    <ol>
                        <li>...</li>
                        <li>...</li>
                        <li>...</li>
                        <li>...</li>
                    </ol>
                </li>
                <li className="level-1">...
                    <ol>
                        <li>...
                            <ol>
                                <li>...</li>
                                <li>...</li>
                            </ol>
                        </li>
                        <li>...</li>
                    </ol>
                </li>
                <li className="level-1">...
                    <ol>
                        <li>...</li>
                        <li>...</li>
                    </ol>
                </li>
            </ol>
        </section>
    )
}

export default BrandRules
